module.exports = __webpack_public_path__ + "static/mindwave-tutorial-ac8a5cfa7194d11761bf71a7d2927995.png";